import { createElement, type FC, type ReactNode } from 'react'

interface CallOutProps {
  children: ReactNode
}

interface CallOutTitleProps {
  children: ReactNode
  level: '1' | '2' | '3' | '4' | '5' | '6'
}

export const Callout: FC<CallOutProps> = ({ children }) => {
  return <div className="border rounded-2xl bg-slate-50 p-8 space-y-2">{children}</div>
}

export const CalloutTitle: FC<CallOutTitleProps> = ({ children, level }) => {
  return createElement(`h${level}`, { className: 'mt-0' }, children)
}
